export const environment = {
  production: false,
  apiUrl: 'https://chargeit-auth-api.cpit.dev',
  keycloakConfig: {
    url: 'https://auth.cpit.dev',
    realm: 'cpit-dev',
    clientId: 'chargeit-auth-frontend',
  },
  /** Off until SMTP is configured for the realm — hides every "send email" option (reset links, invitations, verification). */
  emailEnabled: false,
};
